import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProdutoList.css';
import api from '../services/api';
import { toast } from 'react-toastify';

function ClienteForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditing = Boolean(id);

  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [endereco, setEndereco] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isEditing) fetchCliente();
  }, [id]);

  const fetchCliente = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const res = await api.get(`/clientes/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setNome(res.data.nome);
      setEmail(res.data.email);
      setTelefone(res.data.telefone || '');
      setEndereco(res.data.endereco || '');
    } catch {
      toast.error('Erro ao carregar o cliente.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const data = { nome, email, telefone, endereco };
    const token = localStorage.getItem('access_token');
    const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
    try {
      if (isEditing) {
        await api.put(`/clientes/${id}/`, data, { headers });
        toast.success('Cliente atualizado com sucesso!');
      } else {
        await api.post('/clientes/', data, { headers });
        toast.success('Cliente cadastrado com sucesso!');
      }
      navigate('/clientes');
    } catch (err) {
      if (err._planLimitHandled) return;
      toast.error(isEditing ? 'Erro ao atualizar o cliente.' : 'Erro ao cadastrar o cliente.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="produto-page">

      <div className="produto-page-header">
        <div className="produto-page-title-row">
          <h2 className="produto-page-title">Clientes</h2>
          <div className="produto-tabs">
            <span className="produto-tab active">
              {isEditing ? 'Editar Cliente' : 'Novo Cliente'}
            </span>
            <span className="produto-tab" onClick={() => navigate('/clientes')}>
              Lista de Clientes
            </span>
          </div>
        </div>
      </div>

      <div className="prd-card prd-form-card">
        <div className="prd-card-accent" />
        <div className="prd-form-body">
          <header className="prd-form-header">
            <h3 className="prd-form-title">Informações do Cliente</h3>
            <p className="prd-form-sub">
              {isEditing
                ? 'Atualize os dados de contato do cliente.'
                : 'Preencha os dados para cadastrar um novo cliente.'}
            </p>
          </header>

          <form onSubmit={handleSubmit}>
            <div className="prd-form-left">
              <div className="prd-form-row3" style={{ gridTemplateColumns: '1fr 1fr' }}>
                <div className="prd-field">
                  <label className="prd-label">Nome Completo</label>
                  <input
                    className="prd-input"
                    type="text"
                    placeholder="Nome do cliente"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    required
                  />
                </div>
                <div className="prd-field">
                  <label className="prd-label">Email</label>
                  <input
                    className="prd-input"
                    type="email"
                    placeholder="email@exemplo.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="prd-form-row3" style={{ gridTemplateColumns: '200px 1fr' }}>
                <div className="prd-field">
                  <label className="prd-label">Telefone</label>
                  <input
                    className="prd-input"
                    type="text"
                    placeholder="(00) 00000-0000"
                    value={telefone}
                    onChange={(e) => setTelefone(e.target.value)}
                  />
                </div>
                <div className="prd-field">
                  <label className="prd-label">Endereço</label>
                  <input
                    className="prd-input"
                    type="text"
                    placeholder="Rua, nº, bairro, cidade"
                    value={endereco}
                    onChange={(e) => setEndereco(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="prd-form-actions" style={{ gridColumn: 'unset', marginTop: '1.5rem' }}>
              <button
                type="button"
                className="prd-btn-cancel"
                onClick={() => navigate('/clientes')}
              >
                Cancelar
              </button>
              <button type="submit" className="prd-btn-save" disabled={saving}>
                <span className="material-symbols-outlined">save</span>
                {saving ? 'Salvando...' : isEditing ? 'Salvar Alterações' : 'Cadastrar Cliente'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ClienteForm;
